module.exports = __webpack_public_path__ + "img/option_icon.0eaf2016.svg";